type G2ExternalIdTextField = {
  formatExternalId: (value: string) => string;
};

const useG2ExternalIdTextField = (): G2ExternalIdTextField => {
  const formatExternalId = (value: string): string => {
    if (!value) return '';

    const formattedValue = value
      .toUpperCase()
      .replaceAll(/[^A-Z0-9]/g, '')
      .slice(0, 6);
    return formattedValue.match(/.{1,2}/g)?.join('-') || formattedValue;
  };

  return {
    formatExternalId,
  };
};

export default useG2ExternalIdTextField;
